export const CANVAS_ID = "canvas-share";
